import React, { useState } from "react";
import { Box, Button, Grid2, Typography } from "@mui/material";

const EditStep4 = ({ tender, setTender, user, setStep }) => {
  const [errors, setErrors] = useState({});
  const [inWords, setInWords] = useState();

  const handleChange = (e) => {
    setTender({ ...tender, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
    setInWords(
      e.target.name === "annualTurnover"
        ? convertToWords(Number(e.target.value)) + " Rupees Only"
        : inWords,
    );
  };

  const validateForm = () => {
    const newErrors = {};
    const data = tender || {};

    const isEmpty = (value) => !value || value.trim?.() === "";

    if (isEmpty(data.annualTurnover))
      newErrors.annualTurnover = "Annual Turnover is required";
    if (isEmpty(data.expYears))
      newErrors.expYears = "Years of experience is required";
    if (isEmpty(data.expSimilarWork))
      newErrors.expSimilarWork = "Experience of similar work is required";
    if (isEmpty(data.totalEmp))
      newErrors.totalEmp = "Number of employees is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (!validateForm()) return;
    if (tender.isSingleBid) {
      setStep((prev) => prev + 2);
    } else {
      setStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (tender.isSingleBid) {
      setStep((prev) => prev - 2);
    } else {
      setStep((prev) => prev - 1);
    }
  };

  const convertToWords = (num) => {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const inWords = (n) => {
      if (n < 20) return a[n];
      if (n < 100)
        return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
      if (n < 1000)
        return (
          a[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 ? " and " + inWords(n % 100) : "")
        );
      if (n < 100000)
        return (
          inWords(Math.floor(n / 1000)) +
          " Thousand" +
          (n % 1000 ? " " + inWords(n % 1000) : "")
        );
      if (n < 10000000)
        return (
          inWords(Math.floor(n / 100000)) +
          " Lakh" +
          (n % 100000 ? " " + inWords(n % 100000) : "")
        );
      return (
        inWords(Math.floor(n / 10000000)) +
        " Crore" +
        (n % 10000000 ? " " + inWords(n % 10000000) : "")
      );
    };

    return inWords(num);
  };

  return (
    <div>
      <h2>Edit Tender</h2>
      <div className="progress-container">
        <span className="blue-bar" style={{ width: "66%" }}></span>
      </div>
      {/* <div className="dashboard-container">
        <Typography className="form-title">Compilance</Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="isMSME">Do you belong to MSME?</label>
            <select
              name="isMSME"
              id="isMSME"
              className={`${errors.isMSME && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.isMSME}
            >
              <option value="">-Choose-</option>
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
            {errors.isMSME && <p className="error">{errors.isMSME}</p>}
          </Grid2>
        </Grid2>
      </div> */}
      <div className="dashboard-container">
        <Typography className="form-title">
          Additional Qualification/Data Required
        </Typography>
        <Grid2 container columnSpacing={2}>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="annualTurnover">Annual Turnover (in &#8377;)</label>
            <input
              type="number"
              id="annualTurnover"
              name="annualTurnover"
              className={`${errors.annualTurnover && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.annualTurnover}
            />
            {inWords && (
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "700",
                  marginTop: "-4%",
                }}
              >
                In Words: {inWords}
              </p>
            )}
            {errors.annualTurnover && (
              <p className="error">{errors.annualTurnover}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="expYears">
              Total Number of years of experience
            </label>
            <input
              type="number"
              name="expYears"
              id="expYears"
              className={`${errors.expYears && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.expYears}
            />
            {errors.expYears && <p className="error">{errors.expYears}</p>}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="expSimilarWork">Experience of similar work</label>
            <input
              type="number"
              id="expSimilarWork"
              name="expSimilarWork"
              className={`${errors.expSimilarWork && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.expSimilarWork}
            />
            {errors.expSimilarWork && (
              <p className="error">{errors.expSimilarWork}</p>
            )}
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 4 }}>
            <label htmlFor="totalEmp">Number of Employees</label>
            <input
              type="number"
              id="totalEmp"
              name="totalEmp"
              className={`${errors.totalEmp && "input-error"}`}
              onChange={handleChange}
              value={tender && tender.totalEmp}
            />
            {errors.totalEmp && <p className="error">{errors.totalEmp}</p>}
          </Grid2>
        </Grid2>
      </div>
      <Box className="btn-container" sx={{ gap: 3 }}>
        <Button className="btn-outlined" onClick={handleBack}>
          Back
        </Button>
        <Button className="btn-contained" onClick={handleNext}>
          Next
        </Button>
      </Box>
    </div>
  );
};

export default EditStep4;
